import styled from 'styled-components';

export const StatusBarWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  background: rgb(255, 255, 255);
  width: 100%;
  left: 0px;
  padding: 1.5rem 1rem;
  border-top: 5px solid rgb(75, 40, 109);
  z-index: 1;
`;

export const BoxWrapper = styled.div`
  display: flex;
  padding: 1rem 0;
`;

export const DueMonthlyWrapper = styled.div`
  display: inline-block;
  padding: 0 20px 0 0;
  vertical-align: top;
`;

export const VerticalWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const HorizontalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 14px;
`

export const IntegralPart = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: #2a2c2e;
`;

export const LabelDueMonthly = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
  display: block;
`;

export const PricingBlockMain = styled.div`
  display: flex;
  float: none;
`;

export const BeforeTaxesLabel = styled.div`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 0.875rem;
  -webkit-letter-spacing: -0.6px;
  -moz-letter-spacing: -0.6px;
  -ms-letter-spacing: -0.6px;
  letter-spacing: -0.6px;
  line-height: 1.42857;
  font-weight: 500;
`;

export const DueNowWrapper = styled.div`
  display: inline-block;
  margin: 0 -0.15em;
  padding: 0 20px;
  border-left: solid 1px #acacac;
  vertical-align: top;
`;

export const ModalBottomContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const DownloadQuoteMessageContainer = styled.div`
  width: 100%;
  margin: 20px 0px;
  font-size: 18px;
`;

export const modalStyles = `
  overflow: scroll;
  height: 40%,
  max-height: 40% !important;
  width: 40%;
  position: fixed;
  margin-left: 30%;
  margin-top: 4.5%;
  top: 0;
  left: 0;
  background-color: white;`;
